import { Component, CUSTOM_ELEMENTS_SCHEMA, DestroyRef } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ThemeService } from 'src/core/services/thememanager.service';
import { AuthService } from 'src/core/services/auth.service';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-login',
  imports: [TranslocoModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginComponent {
  theme: string;
  loginButtonLabel = 'Log In';

  constructor(
    private msalService: MsalService,
    private authService: AuthService,
    private themeService: ThemeService,
    private translocoService: TranslocoService,
    private destroyRef: DestroyRef
  ) { }

  title: string;
  version: string;

  ngOnInit(): void {

    this.title = environment.title;
    this.version = environment.version;
    this.themeService.currentTheme$.subscribe(theme => {
      this.theme = theme;
    });

    this.translocoService
      .selectTranslate('login.button.logIn')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(label => {
        this.loginButtonLabel = label || 'Log In';
      });
  }

  onLoginClick = () => {
    this.msalService.instance.loginRedirect({
      redirectStartPage: this.authService.redirectUrl || '/',
      scopes: [...environment.apiConfig.scopes]
    });
  }

}
